export const truncateFromCenter = (value: string): string => {
    return value.substring(0, 9) + '...' + value.substring(value.length - 3, value.length);
}

export const numberWithCommas = (x: any) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}